const CANVAS_SIZE = [238, 404];
let x = Number(Number(Math.random() * 8 + 7).toFixed(0));
let xa = Number(Number(Math.random() * 8 + 7).toFixed(0));
let ya = Number(Number(Math.random() * 3 + 7).toFixed(0));
const SNAKE_START = [
  [x, 17],
  [x, 18],
  [x, 19],
  [x, 20],
];
const APPLE_START = [xa, ya];
const SCALE = 10;
const SPEED = 100;
const DIRECTIONS = {
  38: [0, -1], // up
  40: [0, 1], // down
  37: [-1, 0], // left
  39: [1, 0], // right
};

export { CANVAS_SIZE, SNAKE_START, APPLE_START, SCALE, SPEED, DIRECTIONS };
